import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sellerData: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSellerData: (state, action) => {
      state.sellerData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearSellerData: (state) => {
      state.sellerData = null;
      state.error = null;
    },
  },
});

export const { setSellerData, setLoading, setError, clearSellerData } = authSlice.actions;
export default authSlice.reducer;